import React from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IModalBasicProps } from '../../../models/common/modal';
import { getHyphenatedPhoneNumber } from '../../../utils/general';

export interface IResendInviteModalProps {
  onResendInvite: () => void;
  isLoading: boolean;
  t2cNumber: string;
}

export const ResendInviteModal = ({
  hideModal,
  onResendInvite,
  isLoading,
  t2cNumber,
}: IResendInviteModalProps & IModalBasicProps) => {
  return (
    <>
      <ModalHeader onClose={hideModal}>Resend Text2Confirm Invite</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          A text message will be sent to the number below. The user must reply
          to the text message to confirm Text2Confirm enrollment.
        </Typography>
        <div className="sui-mt-4">
          <Typography variant="body-base" weight="bold" data-qm-mask="">
            {getHyphenatedPhoneNumber(t2cNumber)}
          </Typography>
        </div>
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={hideModal}>
            Cancel
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="primary"
            onClick={onResendInvite}
          >
            Resend Invite
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

ResendInviteModal.displayName = 'ResendInviteModal';
